/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  getWholesaleDiscount: function(product){
    var discountToApply = 1;

    if (window.customer.wholesale) {
      if (window.customer.wholesale_type === 'FOB_SHA' || window.customer.wholesale_type === 'FOB_NL') {
        if (product.tags.includes("international")) {
          discountToApply = window.customer.discount;
        }
      } else {
        discountToApply = window.customer.discount;
      }
    }

    return discountToApply;
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
    .first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

    function callback() {
      $element
      .first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
      ? 'focusout.' + options.namespace
      : 'focusout',
      keydown: options.namespace
      ? 'keydown.' + options.namespace
      : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

function isMobile() {
  return $(window).width() < 750 || window.mobileCheck();
}

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options){
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              $('.option-title').text(currentOption.value);

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },
    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this._updateSwatchTitle(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateSwatchTitle: function(variant){
      $('.option-title').text(variant.title);
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header',
    cartIcon: '.js-cart-icon',
    closeCart: '.js-cart-close',
    slideCart: '.js-slide-cart'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns($(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    cache.$cartIcon.on('click', showSlideCart);
    cache.$closeCart.on('click', hideSlideCart);
    cache.$slideCart.on('mouseleave', hideSlideCart);

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
      .parents('form')
      .submit();
    });

    $(window).resize(
      $.debounce(50, function() {
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      })
    );
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader),
      $cartIcon: $(selectors.cartIcon),
      $closeCart: $(selectors.closeCart),
      $slideCart: $(selectors.slideCart)
    };
  }

  function showSlideCart(evt){
    evt.preventDefault();
    if (isMobile()) {
      cache.$slideCart.toggleClass('active');
    } else {
      cache.$slideCart.addClass('active');
    }
  }

  function hideSlideCart(evt) {
    evt.preventDefault();
    cache.$slideCart.removeClass('active');
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function() {
      var $dropdownLi = $(this).find(selectors.siteNavDropdown);
      if (!$dropdownLi.length) {
        return;
      }
      var isRightOfLogo =
          Math.ceil($(this).offset().left) >
          Math.floor(cache.$siteHeader.outerWidth()) / 2
      ? true
      : false;
      if (isRightOfLogo) {
        $dropdownLi
        .removeClass(config.leftDropdownClass)
        .addClass(config.rightDropdownClass);
      } else {
        $dropdownLi
        .removeClass(config.rightDropdownClass)
        .addClass(config.leftDropdownClass);
      }
    });
  }

  function positionFullWidthDropdowns() {
    var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

    $listWithCenteredDropdown.each(function() {
      var $hasCenteredDropdown = $(this);
      var $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      );

      var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
      $fullWidthDropdown.css('top', fullWidthDropdownOffset);
    });
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu',
    dropdownToggleBtn: 'js-toggle-dropdownmenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);
    cache.$dropdownToggleBtn.on('click', toggleDropdownNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn),
      $dropdownToggleBtn: $('.js-toggle-dropdownmenu')
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
      'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
    .addClass(classes.mobileNavCloseIcon)
    .removeClass(classes.mobileNavOpenIcon)
    .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
    .addClass(classes.mobileNavOpenIcon)
    .removeClass(classes.mobileNavCloseIcon)
    .attr('aria-expanded', false)
    .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      
  
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
       $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function toggleDropdownNav(evt){
    var $toggleBtn = $(evt.currentTarget);
    $toggleBtn.toggleClass("dropdownActive");
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
    ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
    : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
    .css('height', translateMenuHeight)
    .removeClass(classes.thirdNavShowing)
    .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
      .removeClass(classes.thirdNavShowing)
      .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open',
    searchTemplate: 'template-search'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
        slate.utils.getParameterByName('q') !== null &&
        $('body').hasClass(classes.searchTemplate);

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
    .add(selectors.searchHeaderSubmit)
    .on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
    .attr('aria-controls', 'SearchDrawer')
    .attr('aria-expanded', 'false')
    .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
    .removeAttr('aria-describedby')
    .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
    .attr('aria-describedby', 'error-search-form')
    .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function(slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
        .find('li:first-of-type')
        .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function() {
            if (
              this.$arrowsMobile.offset().top +
              this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause');
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay');
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on('click', function() {
      $slideshow.slick('slickPrev');
    });
    this.$arrows.find(selectors.arrowRight).on('click', function() {
      $slideshow.slick('slickNext');
    });

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    this.$wrapper.on('keyup', keyboardNavigation.bind(this));
    this.$controls.on('keyup', keyboardNavigation.bind(this));
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
    .on(
      'focusin',
      function(evt) {
        if (!this.$wrapper.has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (this.autorotate) {
          $slider.slick('slickPause');
        }
      }.bind(this)
    )
    .on(
      'focusout',
      function(evt) {
        if (!this.$wrapper.has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (this.autorotate) {
          // Only resume playing if the user hasn't paused using the pause
          // button
          if (!this.$pause.is('.is-paused')) {
            $slider.slick('slickPlay');
          }
        }
      }.bind(this)
    );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
      .find('a')
      .each(function() {
        var $dot = $(this);
        $dot.on('click keyup', function(evt) {
          if (
            evt.type === 'keyup' &&
            evt.which !== slate.utils.keyboardKeys.ENTER
          )
            return;

          evt.preventDefault();

          var slideNumber = $(evt.target).data('slide-number');

          $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

          if (evt.type === 'keyup') {
            $slider.focus();
          }
        });
      })
      .eq(0)
      .attr('aria-current', 'true');
    }

    this.$controls
    .on('focusin', highlightControls.bind(this))
    .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
    .removeAttr('role')
    .find('li')
    .removeAttr('role')
    .removeAttr('aria-selected')
    .each(function() {
      var $dot = $(this);
      var ariaControls = $dot.attr('aria-controls');
      $dot
      .removeAttr('aria-controls')
      .find('a')
      .attr('aria-controls', ariaControls);
    });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
    .removeAttr('aria-current')
    .eq(nextSlide)
    .attr('aria-current', 'true');

    $mobileDotLinks
    .removeClass(classes.slickActiveMobile)
    .eq(nextSlide)
    .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev');
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext');
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay');
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause');
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
        selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
      $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement)
    .removeClass(classes.supportsAutoplay)
    .removeClass(classes.supportsNoAutoplay)
    .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
       evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(' ');

    if (isMobile()) {
      $videoWrapper.removeAttr('style');
    }

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.a.id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
      .removeClass(classes.wrapperMinHeight)
      .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $('html, body').animate(
          {
            scrollTop: elementTop - offset
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height');
      } else {
        newHeight = video.$videoWrapper.data('desktop-height');
      }

      video.$videoWrapper
      .height(video.$videoWrapper.width() / videoOptions.ratio)
      .animate({ height: newHeight }, 600);
      setTimeout(function() {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      'style',
      'height: ' + video.$videoWrapper.height() + 'px'
    );

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      var playerId = $(document.activeElement).data('controls');
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.backgroundVideo).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr('style');
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data('desktop-height');

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
        .width(playerWidth)
        .height(desktopHeight)
        .css({
          left: (videoWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
        .width(videoWidth)
        .height(desktopHeight)
        .css({
          left: 0,
          top: (desktopHeight - desktopHeight) / 2
        }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $('#' + playerId)
    .removeClass(classes.backgroundVideo)
    .addClass(classes.videoWithImage);

    setTimeout(function() {
      $('#' + playerId).removeAttr('style');
    }, 600);

    videos[playerId].$videoWrapper
    .removeClass(classes.backgroundVideoWrapper)
    .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    $('#' + playerId)
    .removeClass(classes.videoWithImage)
    .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($('#' + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      $(evt.currentTarget).blur();
      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });

    $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      togglePause(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(200, function() {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find('.' + classes.videoWithImage)
              .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, function() {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
               $(window).scrollTop() ||
               $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
               $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    this.$hero = $(el);
    this.layout = this.$hero.data('layout');
    var $parentSection = $('#shopify-section-' + sectionId);
    var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
    var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

    if (this.layout !== 'fixed_width') {
      return;
    }

    $parentSection.removeClass(classes.indexSectionFlush);
    heroFixedHeight();
    $(window).resize(
      $.debounce(50, function() {
        heroFixedHeight();
      })
    );

    function heroFixedHeight() {
      var contentHeight = $heroContent.height() + 50;
      var imageHeight = $heroImage.height();

      if (contentHeight > imageHeight) {
        $heroImage.css('min-height', contentHeight);
      }
    }
  }

  return hero;
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    // Hide reset password form
    $('#HideRecoverPasswordLink').on(
      'click',
      function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    this.$RecoverHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess')
    .removeClass('hide')
    .focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

      $newAddressForm.toggleClass('hide');
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('hide');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };

  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);

    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';

      $evtTarget
      .toggleClass(config.showEditClass)
      .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');

      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    collectionFilter: '.js-collection-filter',
    productCard: '.js-product-card',
    empty: '.js-empty-collection',
    filterTitles: '.js-collection-title',
    filterItems: '.js-collection-grid__items',
    filterToggle: '.js-filter-toggle',
    filterContainer: '.js-filter-container'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  var activeFilters = {
    lid: [],
    volume: [],
    collection: [],
    age: [],
    colors: '',
    insulation: '',
    newArrival: ''
  }

  // var activeColors = []
  // var activeVolumes = []

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$collectionFilter = $(selectors.collectionFilter, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );
    this.$swatches = $(selectors.swatches)
    this.filterTitles = $(selectors.filterTitles)
    this.filterToggle = $(selectors.filterToggle)
    this.filterContainer = $(selectors.filterContainer)

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this.$collectionFilter.on('click', this._onCollectionFilter.bind(this));
    this.filterTitles.on('click', this._toggleFilterCollapse.bind(this))
    this.filterToggle.on('click', this._toggleFilter.bind(this));

    // When the page is loaded from the cache, we have to clear the collection filter content
    document.addEventListener('filter:refresh', function(event) {
      document.querySelector('.js-collection-filter[data-filter-type="clear"]').click();
    });

    this._initBreakpoints();
    this._collapseInitialFilters();
    this._filterInit();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _filterInit: function(){
      var $productCardArray = Array.from($(selectors.productCard));
      var $volumes = $('.js-collection-filter[data-filter-type="volume"]');
      var $colors = $('.js-collection-filter[data-filter-type="color"]');
      var $lids = $('.js-collection-filter[data-filter-type="lid"]');
      var $collections = $('.js-collection-check[data-filter-type="collection"]');
      //var $newArrival = $('.js-collection-check[data-filter-type="newarrival"]');

      initProductCardImages();
      this.trackWidth = $('.js-product-card-images').find('.slick-track').width() || '3000px';
      this.imgWidth = $('.js-product-card-images').find('.slick-track').find('.slick-active').width() || '180px';

      $volumes.hide()
      $colors.hide()
      $lids.hide()
      $collections.hide()
      //$newArrival.hide()

      $productCardArray.forEach(card => {
        var vol = card.dataset.volume;
        var colors = card.dataset.color;
        var lid = card.dataset.lid;
        var collection = card.dataset.collection;
        var colorsArr = colors.split(', ');
        //var newArrival = card.dataset.newArrival;

        $volumes.closest('[data-filter="' + vol + '"]').show();
        $lids.closest('[data-filter="' + lid + '"]').show();
        $collections.closest('[data-filter="' + collection + '"]').show();
        //$newArrival.closest('[data-filter="' + newArrival + '"]').show();

        colorsArr.forEach(color => {
          $colors.closest('[data-filter="' + color + '"]').show();
        })
      })
    },

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function() {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
      this.$collectionFilter.off('click', this._onCollectionFilter);
    },

    _toggleFilter: function(e){
      this.filterContainer.toggleClass('active');
    },

    _toggleFilterCollapse: function(e){
      var $target = $(e.target);
      $target.siblings(selectors.filterItems).toggle();
      $target.toggleClass('closed');
    },

    _collapseInitialFilters: function(){
      $(selectors.filterTitles + '.closed').siblings(selectors.filterItems).toggle();
    },

    _newarrivalFilter: function(card){
      return (activeFilters.newArrival === '' || (activeFilters.newArrival === card.dataset.newArrival))
    },

    _insulationFilter: function(card){
      return (activeFilters.insulation === '' || (activeFilters.insulation === card.dataset.insulated))
    },

    _lidFilter: function(card){
      return (activeFilters.lid.length === 0 || activeFilters.lid.includes(card.dataset.lid))
    },

    _volumeFilter: function(card){
      return (activeFilters.volume.length === 0 || activeFilters.volume.includes(card.dataset.volume))
    },

    _collectionsFilter: function(card){
      return (activeFilters.collection.length === 0 || activeFilters.collection.includes(card.dataset.collection))
    },

    _ageFilter: function(card){
      var ages = card.dataset.age.split(', ')
      var output = false;
      if (activeFilters.age.length === 0) {
        return true
      }
      ages.forEach(function(age){
        if (activeFilters.age.includes(age)) {
          output = true;
        }
      })
      return output;
    },

    _colorFilter: function(card){
      var colors = card.dataset.color.split(', ')
      var output = false;
      if (activeFilters.colors === "") {
        return true
      }
      colors.forEach(function(color){
        if (activeFilters.colors === color) {
          output = true;
        }
      })


      return output;
    },

    _handleGlobalColorSwitch: function(color){
      // var $quickImages = $('.js-product-card-images')
      var $activeSwatches = $('.js-color-swatch[data-color="' + color + '"]')
      $activeSwatches.click()
    },

    _resetImageWidth: function(){
      $('.js-product-card-images').find('.slick-track').width(this.trackWidth);
      var $selected = $('.js-product-card-images').parents('.js-product-card').find('.js-color-swatch.selected')
      $('.js-product-card-images').parents('.js-product-card').find('.js-color-swatch').click()
      $selected.click()
    },

    _onCollectionFilter: function(e){
      // this function controls the
      var $productCardArray = Array.from($(selectors.productCard));
      var dataset = $(e.target).data();

      switch (dataset.filterType) {
        case "newarrival":
          if (activeFilters.newArrival === ("" + dataset.filter)) {
            $(e.target).removeAttr('checked');
            activeFilters.newArrival = "";
          } else {
            activeFilters.newArrival = "" + dataset.filter;
          }
          break;
        case "insulation":
          if (activeFilters.insulation === ("" + dataset.filter)) {
            $(e.target).removeAttr('checked');
            activeFilters.insulation = "";
          } else {
            activeFilters.insulation = "" + dataset.filter;
          }
          break;
        case "lid":
          // toggle selected class here
          $(e.target).toggleClass('selected')
          if (activeFilters.lid.includes(dataset.filter)) {
            var index = activeFilters.lid.indexOf(dataset.filter)
            activeFilters.lid.splice(index, 1);
          } else {
            activeFilters.lid.push(dataset.filter);
          }
          break;
        case "volume":
          $(e.target).toggleClass('selected');
          if (activeFilters.volume.includes(dataset.filter)) {
            var index = activeFilters.volume.indexOf(dataset.filter)
            activeFilters.volume.splice(index, 1);
          } else {
            activeFilters.volume.push(dataset.filter);
          }
          break;
        case "collection":
          if (activeFilters.collection.includes(dataset.filter)) {
            var index = activeFilters.collection.indexOf(dataset.filter)
            activeFilters.collection.splice(index, 1);
          } else {
            activeFilters.collection.push(dataset.filter);
          }
          break;
        case "age":
          if (activeFilters.age.includes(dataset.filter)) {
            var index = activeFilters.age.indexOf(dataset.filter)
            activeFilters.age.splice(index, 1);
          } else {
            activeFilters.age.push(dataset.filter);
          }
          break;
        case "color":
          $(e.target).siblings().removeClass('selected');
          $(e.target).toggleClass('selected');
          if (activeFilters.colors === dataset.filter) {
            // var index = activeFilters.colors.indexOf(dataset.filter)
            // activeFilters.colors.splice(index, 1);
            activeFilters.colors = ""
          } else {
            activeFilters.colors = dataset.filter;
          }
          break;
        case "clear":
          // return to default state
          activeFilters = {
            lid: [],
            volume: [],
            collection: [],
            age: [],
            colors: "",
            insulation: '',
            newArrival: ''
          }

          // remove selected / checked from all filters
          $(selectors.collectionFilter).removeClass('selected')
          $(selectors.collectionFilter).removeAttr('checked')
          default: break;
      }

      var count = 0;
      var self = this;

      $productCardArray.forEach(function(card){
        // check for filter match
        if (self._insulationFilter(card) &&
            self._lidFilter(card) &&
            self._volumeFilter(card) &&
            self._collectionsFilter(card) &&
            self._ageFilter(card) &&
            self._colorFilter(card) &&
            self._newarrivalFilter(card)
           ) {
          card.classList.remove('hidden');
          count++;
        } else {
          card.classList.add('hidden');
        }
      })

      // this._resetImageWidth();

      if (dataset.filterType === 'color') {
        this._handleGlobalColorSwitch(activeFilters.colors);
      }
      // display hidden message if there are no matches!
      if (count === 0) {
        $(selectors.empty).addClass('active');
      } else {
        $(selectors.empty).removeClass('active');
      }
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };

          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;

        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }

        // Show errors only to merchant in the editor.
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.AjaxCart = (function(){
  var cache = cache || {};

  var urls = {
    cart: '/cart.js',
    update: '/cart/change.js'
  }

  var selectors = {
    cartCount: '.js-cart-count', // cart count number
    pretotal: '.js-cart-pretotal',
    savings: '.js-cart-savings',
    subtotal: '.js-cart-subtotal', // cart subtotal
    shipping: '.js-shipping',
    cartItems: '.js-cart-items',
    minicartItems: '.js-mini-cart-items',
    cartRemove: '.js-cart-remove',
    qtyUpdate: '.js-cart-qty',
    emptyCart: '.js-empty-cart',
    fullCart: '.js-full-cart'
  }

  function cacheSelectors() {
    cache = {
      $cartCount: $(selectors.cartCount),
      $pretotal: $(selectors.pretotal),
      $savings: $(selectors.savings),
      $subtotal: $(selectors.subtotal),
      $shipping: $(selectors.shipping),
      $minicartItems: $(selectors.minicartItems),
      $cartItems: $(selectors.cartItems),
      $emptyCart: $(selectors.emptyCart),
      $fullCart: $(selectors.fullCart)
    }
  }

  // aa ajax cart methods
  const AjaxCart = {

    _init: function(){
      AjaxCart._getCart(AjaxCart._refreshCart);
    },

    _refreshCart: function(cart){
      // update cart count universally
      cache.$cartCount.text(cart.item_count);
      // checks for empty cart
      if (cart.item_count > 0) {
        cache.$fullCart.addClass('active')
        cache.$emptyCart.removeClass('active')
        cache.$cartCount.parent().removeClass('hidden');
      } else {
        cache.$fullCart.removeClass('active')
        cache.$emptyCart.addClass('active')
        cache.$cartCount.parent().addClass('hidden');
      }

      var calcFreeShipping = 6000 - cart.items_subtotal_price;
      var newShipping = theme.Currency.formatMoney( calcFreeShipping, theme.moneyFormat);

      if (calcFreeShipping > 0 ){
        var shippingText = " Add <strong>" + newShipping + "</strong>  for free shipping!";
      } else {
        var shippingText = "Your order qualifies for <strong>free shipping! </strong>";
      }

      cache.$shipping.html(shippingText);

      AjaxCart._templateCart(cart, AjaxCart._updateCartTemplate)
    },

    _updateCartTemplate: function(cartTemplate, minicartTemplate, done) {
      if (done) {
        cache.$minicartItems.html(minicartTemplate);
        cache.$cartItems.html(cartTemplate);
      }
    },

    _templateCart: function(cart, callback) {
      // refresh cart items
      var minicartTemplate = "";
      var cartTemplate = "";
      var newSubtotal = 0;
      var preTotal = 0;
      var savings = 0;
      var shipping = 0;

      $.each(cart.items, function(index, item){
        var params = {
          url: '/products/' + item.handle + '.js',
          dataType: 'json'
        }

        var done = false;

        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          url: "/products/" + item.handle + ".js",
          success: function(product) {
            var variant = product.variants.find(function(variant){
              return(variant.id === item.variant_id);
            });

            var discountToApply = slate.utils.getWholesaleDiscount(product);
            var variantPrice = variant.compare_at_price > 0 ? variant.compare_at_price : variant.price;

            newSubtotal += variant.price  * item.quantity;
            preTotal += (variantPrice * discountToApply) * item.quantity;
            if(variant.compare_at_price > 0){
              savings += ((variant.compare_at_price * discountToApply) - (variant.price * discountToApply)) * item.quantity;
            }

            cache.$pretotal.text(theme.Currency.formatMoney(preTotal, theme.moneyFormat));
            cache.$savings.text(theme.Currency.formatMoney(savings, theme.moneyFormat));
            // update cart subtotal
            cache.$subtotal.text(theme.Currency.formatMoney(newSubtotal, theme.moneyFormat));

            if( savings == 0 ){
              $('.js-sale').hide();
            } else {
              $('.js-sale').show();
            }

            // item price string
            var itemPrice = ""
            if (variant.price < variant.compare_at_price){
              itemPrice =  `
                <dl>
                  <dt>
                    <span class="visually-hidden">{{ 'products.product.sale_price' | t }}</span>
                  </dt>
                  <dd>
                    <span class="order-discount">${ theme.Currency.formatMoney(item.final_price * discountToApply) }</span>
                  </dd>
                  <dt>
                    <span class="visually-hidden">${ theme.Currency.formatMoney(item.regular_price * discountToApply) }</span>
                  </dt>
                  <dd>
                    <s class="original-price">${ theme.Currency.formatMoney(variant.compare_at_price * discountToApply)}</s>
                  </dd>
                </dl>
                `
            } else {
              itemPrice = theme.Currency.formatMoney(item.original_price * discountToApply)
            }

            var cartMetaText = ""
            if (item.variant_title && !item.variant_title.includes('Default')) {
              cartMetaText = '<div class="cart__meta-text">'

              item.options_with_values.forEach(function(option){
                cartMetaText += `${option.name}: ${ option.value }<br/>`
              })

              cartMetaText += '</div>'
            }

            // cart meta text

            minicartTemplate += `
              <div class="cart__row">
                <div class="cart__image-wrapper">
                  <img class="cart__image" src="${item.featured_image.url}" alt="${item.featured_image.alt}" data-item-url="${ item.url }">
                </div>
                <div>
                  <div class="cart__meta small--text-left">
                    <div class="list-view-item__title">
                      <a href="${ item.url }" class="cart__product-title">
                        ${ item.product_title }
                        <span> -
                          <div class="cart-price list-view-item__title">
                            ${itemPrice}
                          </div>
                        </span>
                      </a>
                    </div>
                    ${cartMetaText}
              <p class="cart__remove">
              <a href="/cart/change?line=${ index + 1 }&amp;quantity=0" class="text-link js-cart-remove" aria-label="Remove Item ${ item.product_title }">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
              <path id="x-cutout" d="M11.5,23A11.5,11.5,0,0,1,3.368,3.368,11.5,11.5,0,1,1,19.632,19.632,11.425,11.425,0,0,1,11.5,23ZM7.266,5.695a1.5,1.5,0,0,0-1.06,2.561l3.2,3.2L6.26,14.711A1.5,1.5,0,0,0,8.419,16.8l3.109-3.219,3.163,3.164a1.5,1.5,0,0,0,2.121,0,1.5,1.5,0,0,0,0-2.121l-3.2-3.2,3.144-3.255A1.5,1.5,0,0,0,14.6,6.08L11.489,9.3,8.327,6.134A1.491,1.491,0,0,0,7.266,5.695Z" fill="#0c285b"></path>
              </svg>
              </a>
              </p>
              </div>
              <div class="">
              <div class="cart__qty quantity-input">
              <input type='button' value='-' class='qtyminus qtyadjust' field='quantity' />
              <input class="js-cart-qty cart__qty-input quantity-input js-quantityInput" type="number" name="updates[]" id="updates_large_${ item.key }" value="${ item.quantity }" min="0" pattern="[0-9]*" data-item-key="${ item.key }" data-quantity-item="${ index + 1 }">
              <input type='button' value='+' class='qtyplus qtyadjust' field='quantity' />
              </div>
              </div>
              </div>
              </div>
              `

            cartTemplate += `
<div class="cart__row">
<div class="cart__image-wrapper">
<img class="cart__image" src="${item.featured_image.url}" alt="${item.featured_image.alt}" data-item-url="${ item.url }">
</div>
<div>
<div class="cart-price list-view-item__title small--hide">
${itemPrice}
</div>
<svg xmlns="http://www.w3.org/2000/svg" width="67" height="2" viewBox="0 0 67 2" class="price-underline small--hide">
<line id="Line_18" data-name="Line 18" x2="65" transform="translate(1 1)" fill="none" stroke="#0c285b" stroke-linecap="round" stroke-width="2"/>
</svg>
<div class="cart__meta small--text-left">
<div class="list-view-item__title">
<a href="${ item.url }" class="cart__product-title">
${ item.product_title }
<span class=" medium-up--hide"> -
<div class="cart-price list-view-item__title">
${itemPrice}
</div>
</span>
</a>
</div>
${cartMetaText}
<p class="cart__remove">
<a href="/cart/change?line=${ index + 1 }&amp;quantity=0" class="text-link js-cart-remove" aria-label="Remove Item ${ item.product_title }">
<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
<path id="x-cutout" d="M11.5,23A11.5,11.5,0,0,1,3.368,3.368,11.5,11.5,0,1,1,19.632,19.632,11.425,11.425,0,0,1,11.5,23ZM7.266,5.695a1.5,1.5,0,0,0-1.06,2.561l3.2,3.2L6.26,14.711A1.5,1.5,0,0,0,8.419,16.8l3.109-3.219,3.163,3.164a1.5,1.5,0,0,0,2.121,0,1.5,1.5,0,0,0,0-2.121l-3.2-3.2,3.144-3.255A1.5,1.5,0,0,0,14.6,6.08L11.489,9.3,8.327,6.134A1.491,1.491,0,0,0,7.266,5.695Z" fill="#0c285b"></path>
</svg>
</a>
</p>
</div>
<div class="${item.properties.donation_product?.toLowerCase() === 'true' ? 'hidden' : ''}">
<div class="cart__qty quantity-input">
<input type='button' value='-' class='qtyminus qtyadjust' field='quantity' />
<input class="js-cart-qty cart__qty-input quantity-input js-quantityInput" type="number" name="updates[]" id="updates_large_${ item.key }" value="${ item.quantity }" min="0" pattern="[0-9]*" data-item-key="${ item.key }" data-quantity-item="${ index + 1 }">
<input type='button' value='+' class='qtyplus qtyadjust' field='quantity' />
</div>
</div>
</div>
</div>
`
            if (index === cart.items.length - 1) {
              var done = true;
              callback(cartTemplate, minicartTemplate, done)
            }
          }
        })
      })
    },

    _getCart: function(callback){
      var self = this;
      var params = {
        url: urls.cart,
        dataType: 'json'
      };

      jQuery
      .get(params)
      .done(callback)
      .fail(function(response) {
      });
    },

    _removeItem: function(evt) {
      evt.preventDefault();
      var self = this;

      var params = {
        url: self.href,
        dataType: 'json'
      }

      jQuery
      .post(params)
      .done(AjaxCart._refreshCart)
      .fail(function(response) {
      });
    },

    _updateItem: function(evt) {
      evt.preventDefault();
      var self = this;

      var params = {
        url: urls.update,
        data: {
          quantity: parseInt(self.value),
          id: self.dataset.itemKey
        },
        dataType: 'json'
      }

      jQuery
      .post(params)
      .done(AjaxCart._refreshCart)
      .fail(function(response) {
      });
    }
  }

  cacheSelectors();

  $(document).on('click', selectors.cartRemove, AjaxCart._removeItem);
  $(document).on('change', selectors.qtyUpdate, AjaxCart._updateItem);
  // might want an unload func too?

  AjaxCart._init();

  return AjaxCart
})()



theme.Configure = (function(){
  var productJson = $('#ProductJson-configurator');
  if (!productJson.length) {
    return
  }
  var products = JSON.parse(productJson.text());
  products = products.filter(function(product){
    return !product.tags.includes('international')
  })

  var filteredProducts = [];
  var closestProduct = {};

  var foundProduct = products.find(function(product){
    return product.title.toLowerCase() === "kiki® 5oz infant bottle" || product.id === 4309608759389
  })

  if (!foundProduct) {
    foundProduct = products[0]
  }

  var foundVariant = foundProduct.variants[0]


  var selectors = {
    filters: '.js-configurator-filter',
    volumeTagline: '.js-volume-tagline',
    lidTagline: '.js-lid-tagline',
    lidSelect: '.js-configurator__lid-select',
    activeColor: '.js-active-color',
    lidOptions: '.js-configurator-lid',
    colorSwatch: '.js-configurator-filter.color-swatch',
    productForm: '[data-product-form]',
    addToCart: '[data-add-to-cart]',
    productId: '.js-configurator-id',
    productQty: '.js-configurator-qty',
    productPrice: '.js-configurator-price',
    productImage: '.js-product_image.configurator-product-image',
    configOption: '.js-configurator-option',
    optionContent: '.js-option-content',
    configArrows: '.js-configurator-arrow',
    accessoriesToggle: '.js-toggle-accessories',
    accessoriesContainer: '.js-accessories-container',
    accessoryCards: '.js-accessory-cards',
    accessoryDots: '.js-accessory-dot',
    accessorySwatch: '.js-accessory-card .js-color-swatch, .configure-top-card .js-color-swatch',
    accessorySelect: '.single-option-selector',
    accessoryInfo: '.js-acc-info',
    closeTab: '.close',
    accessoryATC: '.js-accessory-atc',
  }

  var cache = {}

  var productQueue = [];

  var filters = {
    volume: "",
    lid: "",
    color: ""
  }

  var lidName = "";

  function _initEventListeners(){
    cache.$filters.on('click', handleFilterClick);
    cache.$configArrows.on('click', handleArrowClick);
    cache.$configOption.on('click', handleOptionToggle);
    cache.$closeTab.on('click', handleOptionToggle);
    cache.$accessoriesToggle.on('click', toggleAccessories);
    cache.$accessoryDots.on('click', handleDotClick);
    cache.$accessorySwatch.on('click', accessorySwatchChange);
    cache.$accessorySelect.on('change', accessorySwatchChange);
    cache.$accessoryInfo.on('click', openAccessoryInfo);
    $(selectors.accessoryATC).on('click', addProductToQueue);

    _initAddToCart();
    initProductCardImages();
    getHiddenColorsForProducts();
  }

  function cacheSelectors(){
    cache = {
      $filters: $(selectors.filters),
      $volumeTagline: $(selectors.volumeTagline),
      $lidSelect: $(selectors.lidSelect),
      $activeColor: $(selectors.activeColor),
      $lidOptions: $(selectors.lidOptions),
      $colorSwatch: $(selectors.colorSwatch),
      $productId: $(selectors.productId),
      $productQty: $(selectors.productQty),
      $productPrice: $(selectors.productPrice),
      $productImage: $(selectors.productImage),
      $configOption: $(selectors.configOption),
      $closeTab: $(selectors.closeTab),
      $configArrows: $(selectors.configArrows),
      $accessoriesToggle: $(selectors.accessoriesToggle),
      $accessoriesContainer: $(selectors.accessoriesContainer),
      $accessoryDots: $(selectors.accessoryDots),
      $accessoryCards: $(selectors.accessoryCards),
      $accessorySwatch: $(selectors.accessorySwatch),
      $accessorySelect: $(selectors.accessorySelect),
      $accessoryInfo: $(selectors.accessoryInfo),
      $lidTagline: $(selectors.lidTagline),
      $accessoryATC: $(selectors.accessoryATC)
    }
  }

  function getHiddenColorsForProducts(){
    products.forEach(function(product){
      var metaParams = {
        url: '/products/' + product.handle + '?view=json'
      }
      var metafields;
      // send request to get metafields
      fetch(metaParams.url)
        .then(res => res.json())
        .then(json => {
          if (json.metafields) {
            product.metafields = json.metafields;
          }
        })
    })
  }

  function handleFilterClick(e){
    var $target = $(this);
    $target.siblings().removeClass('selected');
    $target.toggleClass('selected');

    updateFilters($target.data('filterType'), $target.data('filter'), $target);
  }

  function handleArrowClick(e){
    var $target = $(this);
    if ($target.data('type') === 'volume') {
      var $volumeOptions = cache.$filters.filter('[data-filter-type="volume"]');
      var $selectedOption = $volumeOptions.closest('.selected');
      var $next;
      if (!$selectedOption.length) {
        $selectedOption = $volumeOptions.first();
      }
      if ($target.data('direction') === 'left') {
        $next = $selectedOption.prev();
        if (!$next.length) {
          $next =  $volumeOptions.last();
        }
      } else {
        $next = $selectedOption.next();
        if (!$next.length) {
          $next =  $volumeOptions.first();
        }
      }
      $next.click();
    } else if ($target.data('type') === 'lid') {
      var $lidOptions = cache.$filters.filter('[data-filter-type="lid"]').not('.lid-hidden');
      var $selectedOption = $lidOptions.closest('.selected');
      var selectedIndex = $lidOptions.index($selectedOption);
      var $next;
      if (!$selectedOption.length) {
        $selectedOption = $lidOptions.first();
      }
      if ($target.data('direction') === 'left') {
        nextIndex = selectedIndex - 1;
        $next = $lidOptions.eq(nextIndex);
        if (!$next.length) {
          $next = $lidOptions.last();
        }
      } else {
        nextIndex = selectedIndex + 1;
        $next = $lidOptions.eq(nextIndex);
        if (!$next.length) {
          $next = $lidOptions.first();
        }
      }

      if (filters.lid !== $next.data('filter')) {
        $next.click();
      }
    }
  }

  function handleOptionToggle(e){
    var $target = $(this);
    e.stopPropagation();
    cache.$configOption.removeClass('active');
    $target.addClass('active');

    $('.js-title-addition').text('');
    cache.$configOption.not('.active').each(function(index, item){
      var $item = $(item);
      var $titleAdd = $item.find('.js-title-addition');
      if ($titleAdd.data('option') === "lid") {
        var currentFilter = lidName;
      } else if ($titleAdd.data('option') === "color") {
        if (foundVariant) {
          var currentFilter = foundVariant.title;
        } else {
          var currentFilter = filters[$titleAdd.data('option')];
        }
      } else {
        var currentFilter = filters[$titleAdd.data('option')]
      }

      if (currentFilter) {
        var text = ' • ' + currentFilter.toLowerCase().replace(/-/g, ' ');
        $titleAdd.text(text);
      }
      if ($titleAdd.data('option') === 'tops') {
        if (productQueue.length > 0) {
          var text = ' • ' + (productQueue.length)
          $titleAdd.text(text)
        } else {
          $titleAdd.text('')
        }
      }
    })

    if ( $target.data('title') === 'tops' ) {

      // update to make sure the images all load properly when this thing opens :)
      var trackWidth = $('.configure-top-card .js-product-card-images').find('.slick-track').last().width() || '3000px';
      var imgWidth = $('.configure-top-card .js-product-card-images').find('.slick-track').last().find('.slick-active').width() || '100px';

      $('.configure-top-card .js-product-card-images').find('.slick-track').width(trackWidth);
      $('.configure-top-card .js-product-card-images').find('.slick-track').find('.slick-active').width(imgWidth);
    } else {
      $('.configurator-container').css('height', 'auto');
    }
    cache.$configArrows.removeClass('active');
    var $activeArrows = cache.$configArrows.filter('[data-type=' +  $target.data('option') + ']');
    if ($activeArrows.data('type') === 'lid') {
      if (cache.$filters.filter('[data-filter-type="lid"]').not('.lid-hidden').length > 1) {
        $activeArrows.addClass('active');
      }
    } else {
      $activeArrows.addClass('active');
    }
  }

  function accessorySwatchChange(e){
    var $target = $(this);
    var $card = $target.parents('.js-product-card');
    var handle = $card.data('product');
    var variantId = $target.data('variant');
    var variantVal = $target.val();

    var params = {
      url: '/products/' + handle + '.js',
      dataType: 'json'
    };

    jQuery
    .get(params)
    .done(function(response) {
      var currentVariant = response.variants.find(function(variant){
        if (variantId){
          return variant.id === parseInt(variantId);
        } else if (variantVal) {
          return variant.title === variantVal;
        }
      })

      if (currentVariant) {
        var formattedPrice = theme.Currency.formatMoney(currentVariant.price, theme.moneyFormat);
        $card.find('[data-regular-price]').html(formattedPrice);
        $card.find('input[name="id"]').val(currentVariant.id);

        if (!$card.hasClass('js-accessory-card')) {
          var $atcButton = $card.find('[data-add-to-cart]');
          var $atcText = $card.find('[data-add-to-cart-text]');
          var foundItem = productQueue.find(function(queueItem){
            return queueItem.variantId === currentVariant.id;
          });

          if (foundItem) {
            updateButtonStateToRemove($atcButton, $atcText, $card);
          } else {
            updateButtonStateToAdd($atcButton, $atcText, $card);
          }
        }
      }
    })
    .fail(function(response) {});
  }

  function toggleAccessories(e){
    e.preventDefault();
    e.stopPropagation();
    cache.$accessoriesContainer.toggleClass('open');
  }

  function openAccessoryInfo(e){
    var $target = $(this);
    $target.toggleClass('open');
    if ($target.hasClass('open')) {
      $target.find('.js-acc-info-text').text('- less info');
    } else {
      $target.find('.js-acc-info-text').text('+ more info');
    }
    $target.find('.js-acc-info-content').toggle();
  }

  function handleDotClick(e){
    var $target = $(this);
    $target.siblings().removeClass("active");
    $target.addClass("active");

    cache.$accessoryCards.removeClass("row-0 row-1 row-2 row-3");
    cache.$accessoryCards.addClass($target.data('row'))
  }

  $('.js-accessories-container').hide();

  function addProductToQueue(e){
    // queue items are an object -> { variantID, price, $card, $clone }
    var $this = $(this);

    if (!$this.attr('disabled')){
      var $card = $this.parents('.js-product-card');
      var variantId = parseInt($card.find('[name="id"]').val());
      var price = $card.find('[data-regular-price]').text();
      var $select = $card.find('select');
      if ($select.length > 0) {
        var variantName = $select.val();
      } else {
        // to get the swatch color name
      }

      var foundItem = productQueue.find(function(queueItem){
        return queueItem.variantId === variantId
      })


      if (!foundItem) {
        var $clone = $($card).clone();
        var $clonedSelect = $clone.find('select')
        if ($clonedSelect.length > 0 && variantName) {
          $clonedSelect.val(variantName)
        }

        var item = {
          card: $card,
          clone: $clone,
          variantId: variantId,
          price: price
        }

        // add item to queue
        productQueue.push(item);
        item.clone.prependTo('.queue-item');
        updateButtonState(item.clone);
        updateButtonState(item.card);
        $('.queue-item select').attr("disabled", true);
        $('.queue-item .js-product-card-images').removeClass('slick-slider');

        // reset click event listener so the new cards can have it too :)
        $(selectors.accessoryATC).off('click', addProductToQueue);
        $(selectors.accessoryATC).on('click', addProductToQueue);
      } else {

        var indexInQueue = productQueue.indexOf(foundItem);
        // remove item from queue
        productQueue.splice(indexInQueue, 1);
        // visually remove the card from the queue
        foundItem.clone.remove();
        updateButtonState(foundItem.card);
      }

      updateProductPrice();
    }

    var lengthOfQueue = $('.queue-item div').length;
    if (lengthOfQueue > 1){
      $('.js-accessories-container').show();
    } else {
      $('.js-accessories-container').hide();
    }
  }

  function updateFilters(filterType, filterAmount, $target) {
    if (filters[filterType] === filterAmount) {
      filters[filterType] = ""
    } else {
      filters[filterType] = filterAmount;
    }

    switch (filterType) {
      case "volume":
        filteredProducts = filterProducts();
        removeUnusableLids();
        updateVolumeTagline();
        updateLidTagline($target.data('tagline'));
        break;
      case "lid":
        filteredProducts = filterProducts();
        updateLidTagline($target.data('tagline'));
        lidName = $target.data('filterName');
        break;
      case "color":
        filteredProducts = filterProducts();
        checkProductReady();
        break;
    }

    removeUnusableColors();
    findClosestVariant();
    updateActiveColor();
  }

  function checkProductReady(){
    if (filters["volume"] && filters["lid"] && filters["color"]) {
      $('.configurator-add-to-cart').addClass('ready');
      $('.configurator-image-container').addClass('ready');
    } else {
      $('.configurator-add-to-cart').removeClass('ready');
      $('.configurator-image-container').removeClass('ready');
    }
  }

  function updateVolumeTagline(){
    cache.$volumeTagline.hide();
    if (filters.volume) {
      cache.$volumeTagline.closest('[data-volume=' + filters.volume + ']').show();
    }
  }

  function updateLidTagline(tagline){
    if (filters['lid'] === 'natural vent nipple') {
      switch (filters['volume']) {
        case '5oz':
          tagline = "Slow-flow inspired by moms for natural feeding"
          break;
        case '9oz': case '11oz':
          tagline = "Medium-flow for growing babies (3 mo. +)"
          break;
      }
    }

    cache.$lidTagline.text(tagline)
  }

  function updateActiveColor(){
    if (foundVariant) {
      cache.$activeColor.text(foundVariant.title);
    } else if (filters.color) {
      cache.$activeColor.text(filters.color);
    } else {
      cache.$activeColor.text('');
      cache.$colorSwatch.removeClass('selected');
    }
  }

  function filterProducts(){
    var filtered = products.filter(function(product){
      var volumeTag;
      var volume = "";
      var lidTag;
      var lid = "";

      product.tags.forEach(function(tag){
        if (tag.includes('volume: ')){
          volumeTag = tag;
        } else if (tag.includes('lid: ')) {
          lidTag = tag;
        }
      });
      if (volumeTag) {
        volume = volumeTag.split('volume: ')[1]
      }
      if (lidTag) {
        lid = lidTag.split('lid: ')[1]
      }
      return (filters.volume === "" || volume === filters.volume) && (filters.lid === "" || lid === filters.lid);
    })

    if (!filtered.length) {
      filters.lid = ""

      filtered = products.filter(function(product){
        var volumeTag;
        var volume = "";
        var lidTag;
        var lid = "";

        product.tags.forEach(function(tag){
          if (tag.includes('volume: ')){
            volumeTag = tag;
          } else if (tag.includes('lid: ')) {
            lidTag = tag;
          }
        });
        if (volumeTag) {
          volume = volumeTag.split('volume: ')[1]
        }
        if (lidTag) {
          lid = lidTag.split('lid: ')[1]
        }
        return (filters.volume === "" || volume === filters.volume) && (filters.lid === "" || lid === filters.lid);
      })
    }
    // filters the products down based on the current filters
    return filtered;
  }

  function productsByVol(){
    return products.filter(function(product){
      var volumeTag;
      var volume = "";

      product.tags.forEach(function(tag){
        if (tag.includes('volume: ')){
          volumeTag = tag;
        }
      });
      if (volumeTag) {
        volume = volumeTag.split('volume: ')[1]
      }
      console.log(filters.volume)
      return (filters.volume === "" || volume === filters.volume);
    })
  }

  function findClosestVariant(){
    // finds the best match based on the selected color
    // order the variant selections in priority
    // @arren - refactor eventually with priotized variant selection

    // var priority = {
    // 1: "color matfhes filter",
    // 2: 'aqua',
    // 3: pink swirl,
    // 4: next non-hidden, available variant
    // }
    // sort keys of priority by number
    // pick first

    foundVariant = undefined;
    if (filters.color) {
      filteredProducts.forEach(function(product){
        var hiddenVariants = []
        if (product.metafields && product.metafields.hidden_variants) {
          hiddenVariants = product.metafields.hidden_variants.toLowerCase().split(",")
        }

        product.variants.forEach(function(variant){
          if (variant.title === filters.color  && !hiddenVariants.includes(variant.title.toLowerCase())) {
            foundVariant = variant;
          }
        })
      })
    }

    if (!foundVariant) {
      if (filteredProducts.length > 0) {
        var product = filteredProducts[0]
        var hiddenVariants = []
        if (product.metafields && product.metafields.hidden_variants) {
          hiddenVariants = product.metafields.hidden_variants.toLowerCase().split(",")
        }

        foundVariant = product.variants.find(function(variant){
          if (!hiddenVariants.includes(variant.title.toLowerCase())) {
            return variant.title === "Aqua";
          }
        })

        if (!foundVariant) {
          foundVariant = product.variants.find(function(variant){
            if (!hiddenVariants.includes(variant.title.toLowerCase())) {
              return variant.title === "Pink Swirl";
            }
          })
        }

        if (!foundVariant) {
          foundVariant = product.variants.find(function(variant){
            if (!hiddenVariants.includes(variant.title.toLowerCase())) {
              return true;
            }
          })
        }
      }
    }
    if (foundVariant) {
      updateProductForm();
    }
  }

  function updateProductForm(){
    updateProductPrice();
    cache.$productId.val(foundVariant.id)
    cache.$productImage.attr('src', foundVariant.featured_image.src)
  }

  function updateProductPrice(){
    var additionalPrice = 0
    productQueue.forEach(function(queueItem){
      var stringPrice = queueItem.price.replace("$", '');
      var floatPrice = parseFloat(stringPrice);
      var formattedPrice = floatPrice * 100;
      additionalPrice += formattedPrice;
    })

    var price = theme.Currency.formatMoney(foundVariant.price + additionalPrice, theme.moneyFormat);
    cache.$productPrice.text(price);
    // needs to add up all products in the queue... OI
  }

  function removeUnusableLids(){
    // disables unusuable filtering options from the UI
    var lids = []
    productsByVol().forEach(function(product){
      product.tags.forEach(function(tag){
        console.log(product.title + " " + product.tags);
        if (tag.includes('lid: ')) {
          var lid = tag.split('lid: ')[1]
          if (!lids.includes(lid)) {
            lids.push(lid)
          }
        }
      })
    })

    cache.$lidOptions.hide();
    cache.$lidOptions.addClass('lid-hidden');
    lids.forEach(function(lid){
      cache.$lidOptions.closest('[data-filter=' + lid + ']').show();
      cache.$lidOptions.closest('[data-filter=' + lid + ']').removeClass('lid-hidden');
    })
    var $firstLid = cache.$lidOptions.not('.lid-hidden').closest('[data-filter=' + filters.lid + ']')
    if (!$firstLid.length) {
      $firstLid = cache.$lidOptions.not('.lid-hidden').first();
    }
    if (filters.lid !== $firstLid.data('filter')) {
      $firstLid.click();
    }
  }

  function removeUnusableColors(){
    var colors = []

    filteredProducts.forEach(function(product) {

      var hiddenVariants = []
      if (product.metafields && product.metafields.hidden_variants) {
        hiddenVariants = product.metafields.hidden_variants.toLowerCase().split(",")
      }

      product.variants.forEach(function(variant){
        if (!colors.includes(variant.title)) {
          if (hiddenVariants.includes(variant.title.toLowerCase())) {
          } else {
            colors.push(variant.title);
          }
        }
      })
    })

    cache.$colorSwatch.hide();

    colors.forEach(function(color){
      cache.$colorSwatch.closest('[data-filter=' + color + ']').show();
    })
  }

  function updateButtonState(data){
    var $atcButton = data.find('[data-add-to-cart]');
    var $atcText = data.find('[data-add-to-cart-text]');

    if ($atcButton.hasClass('remove') || $atcButton.hasClass('added')) {
      // toggles back to normal add state
      updateButtonStateToAdd($atcButton, $atcText, data);
    } else {
      if (data.hasClass('product-form-configurator') || data.hasClass('js-accessory-form')) {
        // main configurator button, revert to OG state
        updateButtonStateToAdd($atcButton, $atcText, data);
      } else {
        updateButtonStateToRemove($atcButton, $atcText, data);
      }
    }
  }

  function updateButtonStateToRemove(button, text, data){
    text.text('remove');
    button.removeClass('added').addClass('remove');
  }

  function updateButtonStateToAdd(button, text, data){
    if (data.hasClass('product-form-configurator')) {
      text.text('add to cart');
      button.removeClass('added remove');
    } else {
      text.text('add');
      button.removeClass('added remove');
    }
  }

  function _initAddToCart() {
    var self = this;

    $(selectors.productForm).on('submit', function(evt) {
      evt.preventDefault();
      var $addToCart = $(this).find(selectors.addToCart);

      if ($addToCart.is('[disabled]')) return;
      var $data = $(this);
      _addItemToCart($data);
    });
  }

  function _addItemToCart(data) {
    if (data.hasClass('js-accessory-form')) {
      var variantId = parseInt(data.find('[name="id"]').val());
      var quantity = parseInt(data.find('.js-quantityInput').val());
    } else {
      var variantId = parseInt(cache.$productId.val())
      var quantity = parseInt(cache.$productQty.val())
      }

    var body = {
      items: [
        {
          quantity: quantity,
          id: variantId
        }
      ]
    }

    if (data.hasClass('product-form-configurator')) {
      productQueue.forEach(function(queueItem){
        body.items.push({
          quantity: 1,
          id: queueItem.variantId
        })
      });
    }

    var params = {
      url: '/cart/add.js',
      data: body,
      dataType: 'json'
    };

    jQuery
    .post(params)
    .done(function(response) {
      updateButtonState(data);
  
      $('.js-cart-icon').click();
      
      theme.AjaxCart._getCart(theme.AjaxCart._refreshCart);
      })
    .fail(function(response) {});
  }

  cacheSelectors();
  _initEventListeners();
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      hidden: 'hide',
      inputError: 'input--error',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
      productFormErrorMessageWrapperHidden:
      'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb'
    };

    this.errors = {
      quantityMinumumMessage: theme.strings.quantityMinimumMessage
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
      .on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      })
      .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;

      $(self.selectors.productForm, self.$container).on('submit', function(evt) {
        evt.preventDefault();

        var $addToCart = $(self.selectors.addToCart, self.$container);
        var isInvalidQuantity = self.$quantityInput.val() <= 0;

        if ($addToCart.is('[disabled]')) return;

        if (isInvalidQuantity) {
          self._showErrorMessage(self.errors.quantityMinumumMessage);
        } else {
          var $data = $(self.selectors.productForm, self.$container);
          var redirectUrl = $data.data('product-form-redirect-url');

          self._addItemToCart($data, redirectUrl);
        }
      });
    },

    _addItemToCart: function(data, redirectUrl) {
      // get product metafields request pre-post
      var self = this;
      var params = {
        url: '/cart/add.js',
        data: jQuery(data).serialize(),
        dataType: 'json'
      };

      jQuery
      .post(params)
      .done(function(response) {
        // open the cart
        $('.js-cart-icon').click();
        
        // fetch(window.Shopify.routes.root + 'cart.js')
        // .then(response => {
        //   if (!response.ok) throw new Error('Network response was not ok');
        //   return response.json();
        // })
        // .then(data => {
        //   const donationProducts = new Set([
        //     window.custom.donationProductOneId,
        //     window.custom.donationProductTwoId,
        //     window.custom.donationProductThreeId
        //   ]);
        //   console.log(donationProducts)
        //   // Collect all updates first
        //   const updates = data.items.reduce((acc, item) => {
        //     if (donationProducts.has(item.id)) acc[item.key] = 0;
        //     return acc;
        //   }, {});
      
        //   // Process cart updates sequentially
        //   const updatePromise = Object.keys(updates).length > 0 
        //     ? fetch(window.Shopify.routes.root + 'cart/update.js', {
        //         method: 'POST',
        //         headers: {
        //           'Content-Type': 'application/json',
        //           'Accept': 'application/json'
        //         },
        //         body: JSON.stringify({ updates })
        //       }).then(response => {
        //         if (!response.ok) throw new Error('Update failed');
        //         return response.json();
        //       })
        //     : Promise.resolve();
      
        //   // Always add donation after updates
        //   updatePromise
        //     .then(() => {
        //       const productId = parseInt(localStorage.getItem("donation_product")) || Array.from(donationProducts)[1];;
        //       const quantity = Math.round((data.total_price / 100) * 0.1);
              
        //       return fetch(window.Shopify.routes.root + 'cart/add.js', {
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         body: JSON.stringify({
        //           items: [{ id: productId, quantity, properties:{"donation_product": "true"} }]
        //         })
        //       }).then(response => {
        //         if (!response.ok) throw new Error('Add failed');
        //         return response.json();
        //       });
        //     })
        //     .then(() => {
        //        theme.AjaxCart._getCart(theme.AjaxCart._refreshCart);
        //     })
        //     .catch(error => {
        //       console.error('Cart operation error:', error);
        //     });
        // })
        // .catch(error => {
        //   console.error('Fetch cart error:', error);
        // });
            

        // don't go to the original location
        // window.location.href = redirectUrl;
      })
      .fail(function(response) {
        self._showErrorMessage(response.responseJSON.description);
      });
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
      .removeClass(this.classes.productFormErrorMessageWrapperHidden)
      .attr('aria-hidden', true)
      .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );

      $(this.selectors.productThumbImages)
      .removeClass(this.classes.activeClass)
      .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      // var $newImage = $(
      //   this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
      //   this.$container
      // );
      // var $otherImages = $(
      //   this.selectors.productImageWraps +
      //     ":not([data-image-id='" +
      //     imageId +
      //     "'])",
      //   this.$container

      var imageElmt = $('.js-product_image[data-id=' + imageId + ']').not('.slick-cloned');
      var slickIndex = imageElmt.data('slickIndex');

      $('.product__images-slider').slick('slickGoTo', slickIndex, false);

      // );
      //
      // $newImage.removeClass(this.classes.hidden);
      // $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-list')
      .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-disabled')
      .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('[tabindex="-1"]')
      .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
      .replace('[Regular]', regularLabel)
      .replace('[$$]', regularPrice)
      .replace('[Sale]', saleLabel)
      .replace('[$]', salePrice)
      .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      if (liveRegion) {
        liveRegion.textContent = this._liveRegionText(variant);
        liveRegion.setAttribute('aria-hidden', false);
      }

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart, this.$container).prop('disabled', false);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart, this.$container).prop('disabled', true);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart, this.$container).prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
      // update babylist button
      this._updateBabylistButton(evt);
    },

    _updateBabylistButton: function(evt) {
      var variant = evt.variant;
      var product = this.variants.product;
      
      if (variant) {
        var data = {
            images: `${variant.featured_image ? variant.featured_image.src : product.featured_image.src}`,
            price: `${variant.price / 100}`,
            title: `${product.title} - ${variant.title}`,
            url: `${window.location}`
        };
         $('#AddToBabylist').attr('href', `javascript: bl.addToRegistry(${JSON.stringify(data)})`);
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(variant.id);
      //this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
      .removeClass(this.classes.productUnavailable)
      .removeClass(this.classes.productOnSale)
      .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
        .addClass(this.classes.productUnavailable)
        .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

//*========= AA Product Quick View ===========*//

theme.ProductQuickView = (function(){
  let cache = {}
  let product = {}
  let variant = {}

  var urls = {
    getProduct: '/products/'
  }

  var selectors = {
    quickViewBtn: '.js-quick-view',
    addToCart: '[data-add-to-cart]',
    priceContainer: '[data-price]',
    quickViewProduct: '.js-product-quick-view',
    quickViewContainer: '.js-quick-view-container',
    quickClose: '.js-quick-view-close',
    quickTitle: '.js-quick-title',
    quickDesc: '.js-quick-description',
    quickPrice: '.js-quick-price',
    quickSale: '.js-quick-sale',
    quickVariants: '.js-quick-variants',
    quickImages: '.js-quick-images',
    quickForm: '.js-quick-view-form',
    variantColor: '.js-variant-color',
    quantity: '[data-quantity-input]',
    productReviews: '.js-product-reviews',
    desciptiveBullets: '.js-quick-view-bullets',
    quickLink: '.js-quick-view-link'
  }

  function cacheSelectors() {
    cache = {
      $quickViewBtn: $(selectors.quickViewBtn),
      $quickViewContainer: $(selectors.quickViewContainer),
      $quickClose: $(selectors.quickClose),
      $quickViewProduct: $(selectors.quickViewProduct),
      $quickTitle: $(selectors.quickTitle),
      $quickDesc: $(selectors.quickDesc),
      $quickPrice: $(selectors.quickPrice),
      $quickSale: $(selectors.quickSale),
      $quickVariants: $(selectors.quickVariants),
      $quickImages: $(selectors.quickImages),
      $quickForm: $(selectors.quickForm),
      $productReviews: $(selectors.productReviews),
      $desciptiveBullets: $(selectors.desciptiveBullets),
      $quickLink: $(selectors.quickLink),
      $addToCart: $(selectors.addToCart),
      $priceContainer: $(selectors.priceContainer)
    };
  }

  function ProductQuickView(){
    $(document).on('click', selectors.quickViewBtn, this._openQuickView.bind(this));
    $(document).on('click', selectors.quickClose, this._closeQuickView.bind(this));
    $(document).on('change', '.js-quick-view-container [name="option-color"]', this._handleVariantChange.bind(this))
    $(document).on('change', '.single-option-selector-quickview', this._handleVariantChange.bind(this))
    this._initAddToCart();
  }

  ProductQuickView.prototype = _.assignIn({}, ProductQuickView.prototype, {
    _openQuickView: function(evt){
      evt.preventDefault();
      evt.stopPropagation();
      this.reviews = $(evt.target.parentElement).find('.spr-badge');
      var activeSwatch = $(evt.target.parentElement).find('.js-color-swatch.selected');
      this.variantId = activeSwatch.data('variant');
      this.variantColor = activeSwatch.data('color');
      // get & set the product
      var handle = evt.target.dataset.handle;
      this._getProduct(handle);
    },

    _closeQuickView: function(e) {
      // close the quick view container
      $(selectors.quickViewContainer).removeClass('active');
      if (cache.$quickImages.children().length > 1) {
        cache.$quickImages.slick('unslick');
      }
    },

    _handleVariantChange: function(e){
        console.log(handle)
      var $target = $(e.target);
      var $form = $target.parents('.product-form');
      var $select = $form.find('#ProductSelect-quick-view-template');
      var activeVariant = $target.data('variant') ? $target.data('variant') : $target.val();
      var variantId = $select.find('[data-color="' + activeVariant + '"]').val();
      // update the hidden select
      $select.val(variantId).change();

      if (variantId && product.variants) {
        variant = product.variants.find(prodVariant => prodVariant.id === parseInt(variantId));
      }

      // change the color text
      $(selectors.variantColor).text($target.data('variant'));
      // update the image slider
      this._switchImage(variantId);
      this._switchHref(variantId);
      this._updateATCAvailability();
    },

    _initAddToCart: function() {
      var self = this;

      $(selectors.quickForm, selectors.quickViewContainer).on('submit', function(evt){
        evt.preventDefault();

        var $addToCart = $(selectors.addToCart, selectors.quickViewContainer);
        var isInvalidQuantity = $(selectors.quantity).val() <= 0;

        if ($addToCart.is('[disabled]')) return;

        if (isInvalidQuantity) {
          // self._showErrorMessage(self.errors.quantityMinumumMessage);
        } else {
          var $data = $(selectors.quickForm, selectors.quickViewContainer);
          var redirectUrl = $data.data('product-form-redirect-url');

          self._addItemToCart($data, redirectUrl);
        }
      });
    },

    _addItemToCart: function(data, redirectUrl) {
      var self = this;
      var params = {
        url: '/cart/add.js',
        data: jQuery(data).serialize(),
        dataType: 'json'
      };

      jQuery
      .post(params)
      .done(function(response) {
        $('.js-cart-icon').click();
        theme.AjaxCart._getCart(theme.AjaxCart._refreshCart);
      })
      .fail(function(response) {
        // self._showErrorMessage(response.responseJSON.description);
      });
    },

    _getProduct: function(handle){
      var params = {
        url: urls.getProduct + handle + '.js',
        dataType: 'json'
      };

      var metaParams = {
        url: '/products/' + handle + '?view=json'
      }

      var metafields;
      var self = this;

      jQuery
      .get(params)
      .done(function(response){
        product = response
        // send request to get metafields
        fetch(metaParams.url)
        .then(res => res.json())
        .then(json => {
          // set metafields to product object
          product.metafields = json.metafields
          // template quick shop
          self._templateQuickView();
          // open the quick view container
          cache.$quickViewContainer.addClass('active');
        })
      })
      .fail(function(response) {
      });
    },

    _templateQuickView: function(){
      cache.$quickTitle.text(product.title);
      cache.$quickDesc.text(product.metafields.short_description);
      cache.$desciptiveBullets.html(product.metafields.descriptive_list);
      cache.$quickLink.attr('href', product.url);

      var hiddenVariants = product.metafields.hidden_variants ? product.metafields.hidden_variants.toLowerCase() : "";

      let filteredVariants = product.variants.filter(function(variant){
        return !hiddenVariants.split('|||').find(hiddenVariant => hiddenVariant.toLowerCase() === variant.title.toLowerCase());
      })

      if (this.variantId) {
        variant = filteredVariants.find(filteredVariant => filteredVariant.id === this.variantId);
        this._switchHref(this.variantId);
      } else {
        variant = filteredVariants[0]
      }

      if (product.metafields.descriptive_list) {
        cache.$desciptiveBullets.show();
        cache.$quickViewProduct.css('borderRadius', '30px 30px 0 0');
      } else {
        cache.$desciptiveBullets.hide();
        cache.$quickViewProduct.css('borderRadius', '30px');
      }

      cache.$productReviews.html(this.reviews[0]);

      var discountToApply = slate.utils.getWholesaleDiscount(product);

      if (product.price < product.compare_at_price) {
        cache.$quickSale.text(theme.Currency.formatMoney(product.price * discountToApply));
        cache.$quickPrice.text(theme.Currency.formatMoney(product.compare_at_price * discountToApply));
        cache.$quickSale.show();
        cache.$priceContainer.addClass("price--on-sale");
      } else {
        cache.$quickPrice.text(theme.Currency.formatMoney(product.price * discountToApply));
        cache.$quickSale.hide();
        console.log('regular')
        cache.$priceContainer.removeClass("price--on-sale");
      }

      if (product.variants.length > 1) {
        var quickProductImages = filteredVariants.map(variant => {
          if (variant.featured_image) {
            return `<img class="js-product_image lazyload" data-src="${variant.featured_image.src}" data-id="${variant.id}">`
          } else {
            return null
          }
        }).filter(variant => variant !== null)
      } else {
        var quickProductImages = `<img class="js-product_image lazyload" data-src="${product.featured_image}">`
      }

      cache.$quickImages.html(quickProductImages)

      if (cache.$quickImages.children().length > 1) {
        cache.$quickImages.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          centerMode: false,
          variableWidth: false
        });

        if (this.variantId) {
          this._switchImage(this.variantId);
        } else {
          cache.$quickImages.slick('slickGoTo', 0, false);
        }
      }

      let hasColorOptions = false;

      // product variants
      if (product.variants.length > 0) {
        var options = []

        product.options.forEach((option, optionIndex) => {
          var filteredValues = option.values.filter(function(value){
            return !hiddenVariants.split("|||").find(hiddenVariant => hiddenVariant.toLowerCase() === value.toLowerCase())
          })

          var value = filteredValues[0]

          if (option.name.toLowerCase() === "color" ||  option.name.toLowerCase() === 'size') {
            hasColorOptions = true;

            var values = filteredValues.map((value, index) => {
              return `
              <input type="radio"
                name="option-${option.name.toLowerCase()}"
                value="${value}"
                class="single-option-selector single-option-selector-quick-view-template product-form__input"
                data-variant="${value}"
                id="SingleOptionSelector-${index}-${option.name.toLowerCase()}"
                data-index="option${option.position}"
                ${ index === 0 ? "checked" : ""}
              >
              ${ option.name.toLowerCase() === 'size' ? `<label for="SingleOptionSelector-${index}-${option.name.toLowerCase()}" class="size-option radio-js"> ${ value } </label>` : ''}
              ${ option.name.toLowerCase() === 'color' ? `<label for="SingleOptionSelector-${index}-${option.name.toLowerCase()}" class="color-option radio-js js-color-swatch color-swatch color-swatch-${value.toLowerCase().replace("& ", '').replace(/ /g, "-").replace(', ', '-').replace(',', '').replace('(', '').replace(')', '')}"></label>` : ''}
              `
            }).join('')

            var outerDiv = `
              <div class="selector-wrapper js product-form__item product-selectors" data-option-index="${ optionIndex }">
                <label class="swatch-option-label" ${ option.name === 'default' ? 'class="label--hidden"' : ''} for="SingleOptionSelector-${ optionIndex }">
                  <strong>${ option.name }: </strong><span class="option-title js-variant-color" id="swatchTitle${optionIndex}">${ value }</span>
                </label>
                <div class="product-radio">
                  ${values}
                </div>
              </div>
              `

            options.push(outerDiv)

          } else {
            var values = filteredValues.map((value, index) => {
              return `<option data-variant="${value}" value="${ value }">${ value }</option>`
            }).join('')

            var outerDiv = `
              <div class="selector-wrapper js product-form__item product-selectors" data-option-index="${ optionIndex }">
                <label class="swatch-option-label" ${ option.name === 'default' ? 'class="label--hidden"' : ''} for="SingleOptionSelector-${ optionIndex }">
                  <strong>${ option.name }: </strong><span class="option-title js-variant-color" id="swatchTitle${optionIndex}">${ value }</span>
                </label>
                <select class="single-option-selector single-option-selector-quickview product-form__input" id="SingleOptionSelector-quickview" data-index="option${ optionIndex }">
                  ${values}
                </select>
              </div>
            `

            options.push(outerDiv)
          }
        })
      }

      var variants = filteredVariants.map((variant, index) => {
        if (variant.available) {
          return `
          <option data-color="${variant.title}" ${index === 0 ? 'selected="selected"' : ''} value="${ variant.id }">
          ${ variant.title }
          </option>
          `
        } else {
          return `<option data-color="${variant.title}" disabled="disabled" value="${ variant.id }">${ variant.title } - Sold Out</option>`
        }
      }).join(',')

      var select = `
        <select name="id" id="ProductSelect-quick-view-template" class="product-form__variants no-js js-hidden-select">
        ${variants}
        </select>
      `

      let variantsTemplate = "";

      if (filteredVariants.length > 1 || hasColorOptions) {
         variantsTemplate = `
          ${options.join('')}
          ${select}
        `
      } else {
        variantsTemplate = `
          ${select}
        `
      }

      cache.$quickVariants.html(variantsTemplate);

      if (this.variantColor) {
        var activeSwatch = $('.js-quick-view-container [name="option-color"]').closest('[data-variant="' + this.variantColor + '"]');
        activeSwatch.click();
      }

      this._updateATCAvailability()
    },

    _updateATCAvailability: function(){
      if (variant && variant.available) {
        cache.$addToCart
          .text('add to cart')
          .attr('disabled', false)
      } else {
        cache.$addToCart
          .text('sold out')
          .attr('disabled', true)
      }
    },

    _switchImage: function(imageId) {
      var imageElmt = $('.js-quick-images .js-product_image[data-id=' + imageId + ']').not('.slick-cloned');
      var slickIndex = imageElmt.data('slickIndex');
      cache.$quickImages.slick('slickGoTo', slickIndex, false);
    },

    _switchHref: function(variantId) {
      var href = cache.$quickLink.attr('href');

      if (href.includes('variant=')) {
        href = href.split('?variant=')[0];
        href += '?variant=' + variantId
        cache.$quickLink.attr("href", href);
      } else {
        href += '?variant=' + variantId
        cache.$quickLink.attr("href", href);
      }
    }
  })

  cacheSelectors()

  return ProductQuickView
})();

// *  ============ End Quick View =========== *//

theme.ProductRecommendations = (function() {
  var selectors = {
    productCard: '[data-product-card]'
  };

  function ProductRecommendations(container) {
    this.$container = $(container);

    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
        '/recommendations/products?&section_id=product-recommendations&product_id=' +
        productId +
        '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
          this.sendTrekkieEvent();
          initProductCardImages();
        }
      }.bind(this)
    );
  }

  ProductRecommendations.prototype = _.assignIn(
    {},
    ProductRecommendations.prototype,
    {
      sendTrekkieEvent: function() {
        if (
          !window.ShopifyAnalytics ||
          !window.ShopifyAnalytics.lib ||
          !window.ShopifyAnalytics.lib.track
        ) {
          return;
        }

        var didPageJumpOccur =
            this.$container[0].getBoundingClientRect().top <= window.innerHeight;
        var numberOfRecommendationsDisplayed = this.$container.find(
          selectors.productCard
        ).length;

        window.ShopifyAnalytics.lib.track('Product Recommendations Displayed', {
          theme: 'debut',
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed
        });
      }
    }
  );

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.VideoSection = (function() {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $('.video', $container).each(function() {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr('id'));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('product-quick-view', theme.ProductQuickView);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"],' +
      '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
      '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    imagePlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]'
  };

  var classes = {
    hidden: 'hide'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
    .closest(selectors.imageWithPlaceholderWrapper)
    .find(selectors.imagePlaceholder)
    .addClass(classes.hidden);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + '.lazyloaded')
    .closest(selectors.imageWithPlaceholderWrapper)
    .find(selectors.imagePlaceholder)
    .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();
};



var mediaLarge = window.matchMedia("(min-width: 601px)")
mediaQuery(mediaLarge) // Call listener function at run time


// Popup
$('.popupTrigger').click(function(){
  var index = $(this).attr('data-index');
  $('.popup-wrapper[data-index= ' + index + ']').toggleClass('activate').focus();
  $('.popup-wrapper[data-index= ' + index + '] video' ).trigger('play');
})

$('.js-close').click(function (){
  $('.popup-wrapper').removeClass('activate');
  $('.trigger-pause').trigger('pause');
  $('.pause-video').each(function(index, iframe){
    var source = iframe.src;
    iframe.src = source;
  })
});

//Doesn't work yet
$(document).keydown(function(e) {
  // ESCAPE key pressed
  if (e.keyCode == 27) {
    $('.popup-wrapper').removeClass('activate');
    $('.trigger-pause').trigger('pause');
    $('.pause-video').each(function(index, iframe){
      var source = iframe.src;
      iframe.src = source;
    })
  }
});

//Trigger video cover to play video on click
$(document).ready(function(){
  $('.video-cover svg').click(function(){
    $('.video-cover').hide();
    var iframe = document.getElementById('video');
    var player = $(iframe);
    player.api("play");
    //$('.feature-vid').trigger('play');
  });
})

// get viewport and play correct video
$(document).ready(function(){
  var desktopVideo = $('.js-desktop-video');
  var mobileVideo = $('.js-mobile-video');

  if ($(window).width() < 750) {
    mobileVideo.trigger('play');
    var video = document.getElementById('mobileVideo')
    if (video){
      video.muted = false;
    }
  }
  else {
    desktopVideo.trigger('play');
    var video = document.getElementById('desktopVideo');
    if (video) {
      video.muted = false;
    }
  }
})

//autoplay on safari
//otherwise
$('.main-video').click(function(){
  $(this).trigger('play');
})

// Product Images slider
$(document).ready(function(){
  $('.product__images-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    variableWidth: false
  });

  var index = $('.js-active-variant').data('slickIndex');
  $('.product__images-slider').slick('slickGoTo', index, true);
});

// Values slick slider
var mq = window.matchMedia( "(max-width: 570px)" );
if (mq.matches) {
  $(document).ready(function(){
    $('.multiple-items').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 2000,
      mobileFirst: true
    });
  });
}

// Awards slick slider
$(document).ready(function(){
  $('.variable-width').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true
  });
  $('.static-width').slick();
});


function initProductCardImages(){
  var $swatches =  $('.js-product-card .js-color-swatch');
  $swatches.on('click', _switchColor);
  $swatches.on('click', _changePrice);
  // slick sliders for collection page
  $('.js-product-card-images').slick({
    dots: false,
    infinite: false,
    draggable: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: false,
    variableWidth: false,
    arrows: false
  });

  var trackWidth = $('.js-product-card-images').find('.slick-track').last().width() || '3000px';
  var imgWidth = $('.js-product-card-images').find('.slick-track').last().find('.slick-active').width() || '180px';

  $('.js-product-card-images').find('.slick-track').width(trackWidth);
  $('.js-product-card-images').find('.slick-track').find('.slick-active').width(imgWidth);
  $('.collection-grid__products').css('visibility', 'inherit');

  function _switchColor(e){
    e.preventDefault();
    e.stopPropagation();
    var $target = $(e.target);
    $target.siblings().removeClass('selected');
    $target.addClass('selected');

    var variantId = $target.data('variant');
    var $card = $target.parents('.js-product-card');
    var $slick = $card.find('.js-product-card-images');
    var index = $slick.find('.product-card__image[data-variant="' + variantId + '"]').data('slickIndex');

    $slick.slick('slickGoTo', index, true);

    // aa what all needs to link?
    // Switch Link Sources
    var href = $card.attr("href");
    if (href) {
      if (href.includes('variant=')) {
        href = href.split('?variant=')[0];
        href += '?variant=' + variantId
        $card.attr("href", href);
      } else {
        href += '?variant=' + variantId
        $card.attr("href", href);
      }
    }
  }
  function _changePrice(e){
    var $target = $(e.target);
    var $card = $target.parents('.js-product-card');
    var $cardPrice = $card.find('[data-regular-price]');
    var priceContainer = $card.find('span.price');
    var variantId = $target.data('variant');
    var price = $target.data('variant-price');

    //prevent overriding sale price
    if (priceContainer.hasClass('price--on-sale') === false ){
      $cardPrice.html(theme.Currency.formatMoney(price));
    }

    //hide "from:" text
    $card.find('.from').hide();
  }

}
function collection_pro_grid() {
  $('.featured_collection_grid').slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    draggable: false,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}

// Header Nav
$('.site-nav__mega-menu-products').not(':first').hide();
$(".site-nav__childlist-item:first-child").addClass("drawer-active");

$(".site-nav__childlist-item").click(function(e) {
  e.preventDefault();
  e. stopPropagation();
  $(this).addClass("drawer-active").siblings().removeClass("drawer-active");

  var menuName = $(this).attr('data-name');

  $('.site-nav__mega-menu-products').hide();
  $('.site-nav__mega-menu-products[data-name="' + menuName + '"]').show();
});

//quantity
$(document).on('click', '.qtyadjust', function(){
  var qty = parseInt($(this).parent('.quantity-input').find('.js-quantityInput').val());
  if($(this).hasClass('qtyplus')){
    qty++;
  } else{
    if(qty > 1 ){
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.quantity-input').find('.js-quantityInput').val(qty).change();
});

$('.checkmark').click( function(){
  $(this).siblings('.js-collection-filter').trigger('click');
});

$('.collection-grid__lid-icon').click( function(){
  $(this).parent('.js-lid-click').trigger('click');
});

//BPA page delay GIF loads
function mediaQuery(mediaLarge) {
  if (mediaLarge.matches) {
    $(document).ready(function () {
      $('.load-delay').each(function () {
        var imagex = $(this);
        var delay = imagex.data('delay');
        var imgOriginal = imagex.data('original');
        setTimeout(function () {
          $(imagex).attr('src', imgOriginal);
        }, delay );
      });

    });
  } else {
    $('.load-delay').addClass('lazyload');
  }
}

$('.load-delay').mouseover(function (){
  var imagex = $(this);
  var imgOriginal = imagex.data('original');
  setTimeout(function () {
    $(imagex).attr('src', imgOriginal);
  });
});

$(theme.init);
